import {
	Button,
	ButtonProps,
	Conditional,
	Else,
	If,
	Row,
	toGrammaticalNumber,
	useMediaQuery,
} from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";

export type CommentsViewButtonProps = Omit<ButtonProps, "children"> & {
	numComments: number | undefined;
};

/**
 * Used by other components as a view button that displays either the number of comments (if more than 0) or "view".
 */
export function CommentsViewButton({
	numComments = 0,
	variant = "link",
	size = "small",
	...props
}: CommentsViewButtonProps) {
	const isScreenWide = useMediaQuery("(min-width: 768px)");

	return (
		<Button variant={variant} size={size} {...props}>
			<Conditional>
				<If condition={numComments > 0}>
					<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
						<Icon.Chat size={16} />
						<span>{isScreenWide ? toGrammaticalNumber("Comment", numComments, true) : numComments}</span>
					</Row>
				</If>
				<Else>View</Else>
			</Conditional>
		</Button>
	);
}
